module.exports = __webpack_public_path__ + "static/img/menageBanner.eeba5234.png";